import { render } from "./ManufactureViewForm.vue?vue&type=template&id=303f1628"
import script from "./ManufactureViewForm.vue?vue&type=script&lang=js"
export * from "./ManufactureViewForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__